import React from 'react';
import {
    observer,
    inject
} from 'mobx-react';
import WOHistory from './woHistory';
import { HomeBusiness } from '@business/newCreateRequest/common/home';
var notYestScheduledNoData = '<div>No not yet scheduled</div><div>maintenance requests</div>';
var scheduledVisitsNoData = '<div>No scheduled visits</div><div>&nbsp;</div>';
var CompletedNoData = '<div>No completed</div><div>maintenance requests</div>';
var HomeMaintenanceModule = inject(HomeBusiness)(observer(function (props) {
    var notScheduledWoData = props.notScheduledWoData, scheduledWoData = props.scheduledWoData, completedWoData = props.completedWoData;
    return React.createElement('div', { className: 'rsp-home-maintenance-issues mt-2 pt-3 mb-4' }, React.createElement('div', { className: 'f22 my-3' }, React.createElement('b', null, 'Maintenance issues')), React.createElement('div', { className: 'maintenance-issues-card' }, React.createElement('div', { className: 'dsm-card maintenance-issues-item' }, React.createElement('div', { className: 'default-padding default-border py12' }, React.createElement('img', {
        className: 'sc-icon',
        src: 'https://rsp-front-end-dev.lessen.com/sources/svg/not-yet-scheduled.svg'
    }), React.createElement('span', { className: 'f18 mb-2 ml-3' }, React.createElement('b', null, 'Not yet scheduled'))), React.createElement(WOHistory, {
        woData: notScheduledWoData,
        noDataMsg: notYestScheduledNoData
    })), React.createElement('div', { className: 'dsm-card maintenance-issues-item' }, React.createElement('div', { className: 'default-padding default-border py12' }, React.createElement('img', {
        className: 'sc-icon',
        src: 'https://rsp-front-end-dev.lessen.com/sources/svg/scheduled-visits.svg'
    }), React.createElement('span', { className: 'f18 mb-2 ml-3' }, React.createElement('b', null, 'Scheduled visits'))), React.createElement(WOHistory, {
        woData: scheduledWoData,
        noDataMsg: scheduledVisitsNoData
    })), React.createElement('div', { className: 'dsm-card maintenance-issues-item' }, React.createElement('div', { className: 'default-padding default-border py12' }, React.createElement('img', {
        className: 'sc-icon',
        src: 'https://rsp-front-end-dev.lessen.com/sources/svg/home-completed.svg'
    }), React.createElement('span', { className: 'f18 mb-2 ml-3' }, React.createElement('b', null, 'Completed'))), React.createElement(WOHistory, {
        woData: completedWoData,
        noDataMsg: CompletedNoData
    }))));
}));
export default HomeMaintenanceModule;